import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { UserContext } from "../../common/UserContext";
import config from "../../../envconfig";
import Icon9 from "../../../assest/images/Icon9.png";

function ShipInScanedList() {
  const { selectedScpId } = useContext(UserContext);

  const [userData, setUserdata] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const res = await fetch(
          `${config.API_URL}/Completed_Inward_TableData/${selectedScpId}`
        );
        if (res.ok) {
          const data = await res.json();
          setUserdata(data.CompletdShipment || []);
        } else {
          // toast.error("Error retrieving table data");
          console.error("Error retrieving table data");
        }
      } catch (error) {
        console.error("Failed to fetch table data:", error);
        // toast.error("Failed to fetch table data");
      }
    };
    fetchTableData();
  }, [selectedScpId]);

  const handleViewClick = async (ShipmentID) => {
    try {
      const res = await fetch(
        `${config.API_URL}/Completed_Inward_ViewData/${selectedScpId}/${ShipmentID}`
      );
      if (res.ok) {
        const data = await res.json();
        setPopupData(data.CompletdShipment || []);
        setPopupVisible(true);
      } else {
        toast.error("Failed to retrieve view data");
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
      toast.error("Error fetching view data");
    }
  };

  const handleClosePopup = () => {
    setPopupVisible(false);
    setPopupData(null);
  };

  const handleSearchInputChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  // ✅ Match with API field names
  const filteredUserData = userData.filter((shipment) => {
    const shipmentCode = shipment.ShipmentCode || "";
    return shipmentCode.toLowerCase().includes(searchQuery.toLowerCase());
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentPosts = filteredUserData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div className="main_container">
        <h4 className="formHeading">Completed Inward</h4>
        <div className="row">
          <div className=" col-md-6 mb-3">
            <input
              type="text"
              className="search-input"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="Search by Shipment Code"
            />
          </div>
        </div>
        <table className="scantableClass">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th className="nav-tabs">Shipment Code</th>
              <th className="nav-tabs">View</th>
            </tr>
          </thead>
          <tbody>
            {currentPosts.length > 0 ? (
              currentPosts.map((item, index) => (
                <tr key={item.ShipmentID}>
                  <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                  <td>{item.ShipmentCode}</td>
                  <td>
                    <img
                      src={Icon9}
                      alt="View"
                      title="View"
                      className="pool-button"
                      onClick={() => handleViewClick(item.ShipmentID)}
                    />
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">No Records Found</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        <ul className="pagination">
          <li
            className={
              currentPage === 1 || filteredUserData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(1)}
              disabled={currentPage === 1 || filteredUserData.length === 0}
            >
              First
            </button>
          </li>
          <li
            className={
              currentPage === 1 || filteredUserData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1 || filteredUserData.length === 0}
            >
              Previous
            </button>
          </li>
          {filteredUserData.length > 0 &&
            Array.from(
              {
                length: Math.ceil(filteredUserData.length / itemsPerPage),
              },
              (_, index) => (
                <li
                  key={index}
                  className={
                    currentPage === index + 1
                      ? "page-item active"
                      : "page-item"
                  }
                >
                  <button
                    className="page-linkd"
                    onClick={() => paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                </li>
              )
            )}
          <li
            className={
              currentPage ===
                Math.ceil(filteredUserData.length / itemsPerPage) ||
              filteredUserData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() => paginate(currentPage + 1)}
              disabled={
                currentPage ===
                  Math.ceil(filteredUserData.length / itemsPerPage) ||
                filteredUserData.length === 0
              }
            >
              Next
            </button>
          </li>
          <li
            className={
              currentPage ===
                Math.ceil(filteredUserData.length / itemsPerPage) ||
              filteredUserData.length === 0
                ? "page-item disabled"
                : "page-item"
            }
          >
            <button
              className="page-linkd"
              onClick={() =>
                paginate(Math.ceil(filteredUserData.length / itemsPerPage))
              }
              disabled={
                currentPage ===
                  Math.ceil(filteredUserData.length / itemsPerPage) ||
                filteredUserData.length === 0
              }
            >
              Last
            </button>
          </li>
        </ul>
      </div>

      {/* ✅ Popup Data Fixed */}
      {popupVisible && popupData && (
  <div className="popup-box">
    <div className="popup-content">
      {/* Cross Button at Top Right */}
      <button
        className="popup-close-btn"
        onClick={handleClosePopup}
      >
        &times;
      </button>

      <h4>Shipment Details</h4>
      <table className="scantableClass">
        <thead>
          <tr>
            <th>Product Code</th>
            <th>Product Name</th>
            <th>Order Qty</th>
            <th>Ship Qty</th>
            <th>Scan Qty</th>
            <th>Received Qty</th>
          </tr>
        </thead>
        <tbody>
          {popupData.map((item, index) => (
            <tr key={index}>
              <td>{item.ProductCode}</td>
              <td>{item.ProductName}</td>
              <td>{item.OrderQty}</td>
              <td>{item.ShipQty}</td>
              <td>{item.ScanQty}</td>
              <td>{item.ReceivedQty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}


      <Link to={`/ShipInScanPendingList`} className="back_btn" type="button">
        BACK
      </Link>
    </>
  );
}

export default ShipInScanedList;


